module.exports = __webpack_public_path__ + "static/media/mainpch.3fdc9272.png";